import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { knowledgeOptions } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { oneValueRequiredOwners } from '@app/forms/subscription/services/utile';

@Component({
    selector: 'financial-knowledge3',
    templateUrl: './financial-knowledge3.component.html',
    styleUrls: ['./financial-knowledge3.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class FinancialKnowledge3Component implements OnInit {
  options: FormControlOption[] = knowledgeOptions;
  pledge: PledgeRead = null;
  isConsultant: boolean = false;
  constructor(private subscriptionFacade: SubscriptionFacadeService) {}

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.isConsultant = !!this.subscriptionFacade?.getUser()?.sessionConsultant;
  }
  display(key: 'indexFund' | 'derivativeProducts') {
    if (key === 'indexFund') {
      const knowIndexFund = oneValueRequiredOwners(this.pledge, [
        'knowIndexFund',
      ]);
      if (knowIndexFund) {
        return true;
      }
    } else {
      const knowDerivativeproduct = oneValueRequiredOwners(this.pledge, [
        'knowDerivativeproduct',
      ]);
      if (knowDerivativeproduct) {
        if (this.isConsultant) {
          return true;
        } else return true;
      }
    }
  }
}
